const Config = [ {
    "id": "1",
    "value": "hasAbortionReasonEnumVal",
    "display": "hasAbortionReasonEnumVal",
    "name": "hasAbortionReasonEnumVal"
  },
];

export default Config;